import { sessionStorageWrapper } from 'approot/shared/storage';
import {
  SESSION_IS_STALE_IN_SECONDS_DEV,
  SESSION_IS_STALE_IN_SECONDS_PROD,
} from 'global/constants';
import { isDevEnv } from 'approot/shared/layout/header/header.utils';

const KEY_PREFIX = 'bestBefore';

export const durationInSeconds = isDevEnv()
  ? SESSION_IS_STALE_IN_SECONDS_DEV
  : SESSION_IS_STALE_IN_SECONDS_PROD;

const SESSION_TIMEOUT_DURATION_MILLISECONDS = durationInSeconds * 1000;
const SESSION_COUNTDOWN_DURATION_MILLISECONDS = 1 * 60 * 1000; // 1 mins

export function getTimeSessionStarted() {
  const expiryTime = sessionStorageWrapper.getItem(KEY_PREFIX);
  if (expiryTime) {
    return Number(expiryTime);
  }

  return undefined;
}

export function clearSessionData() {
  sessionStorageWrapper.removeItem(KEY_PREFIX);
}

// Function to extend session
export function resetAndExtendSession() {
  const newExpiryTime = Date.now() + SESSION_TIMEOUT_DURATION_MILLISECONDS;
  sessionStorageWrapper.setItem(KEY_PREFIX, newExpiryTime);
  return newExpiryTime;
}

export function setSessionExpiryTime(newExpiryTime: number) {
  sessionStorageWrapper.setItem(KEY_PREFIX, newExpiryTime);
}

export function isItTimeToShowSessionWarning() {
  const expiryTime = sessionStorageWrapper.getItem(KEY_PREFIX);
  if (expiryTime) {
    const timeLeft = Number(expiryTime) - Date.now();
    if (timeLeft <= SESSION_COUNTDOWN_DURATION_MILLISECONDS) {
      return true;
    } else {
      return false;
    }
  }

  return false;
}

export function initialiseSessionStorageDuration() {
  sessionStorageWrapper.setItem(
    KEY_PREFIX,
    `${Date.now() + SESSION_TIMEOUT_DURATION_MILLISECONDS}`
  );
}
